export const polyfill = async (locale) => {
  // Do nothing until we need polyfills again
};
